import React from 'react';
import {
  SafetyCertificateOutlined,
  DollarCircleOutlined,
  LineChartOutlined,
  HomeOutlined
} from '@ant-design/icons';

const services = [
  {
    icon: <SafetyCertificateOutlined className="text-primary text-5xl" />,
    title: "Pojištění",
    description: "Ochrana zdraví, majetku i příjmů. Vybereme pojištění, která dávají smysl."
  },
  {
    icon: <DollarCircleOutlined className="text-primary text-5xl" />,
    title: "Penze",
    description: "Zajistěte si důstojné stáří pomocí chytrého spoření a daňových výhod."
  },
  {
    icon: <LineChartOutlined className="text-primary text-5xl" />,
    title: "Investice",
    description: "Zhodnocení úspor podle vašich cílů a vztahu k riziku. Jednoduše a přehledně."
  },
  {
    icon: <HomeOutlined className="text-primary text-5xl" />,
    title: "Úvěry",
    description: "Hypotéky a úvěry na míru – výhodné podmínky na novém či stávajícím úvěru."
  },
];

export default function Services () {
  return (
    <section id="sluzby" className="bg-primary px-4 sm:px-6 lg:px-8 py-20 scroll-mt-16">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-extrabold text-light text-3xl sm:text-4xl">
          Pomůžu vám s klíčovými oblastmi financí
        </h2>
        <p className="mt-4 text-dark text-base sm:text-lg leading-relaxed">
          Ať už jde o pojištění, investice nebo bydlení – najdeme řešení, které vám bude dávat smysl.
        </p>
      </div>

      <div className="gap-8 grid sm:grid-cols-2 lg:grid-cols-4 mx-auto mt-16 max-w-7xl">
        {services.map((service, i) => (
          <div
            key={i}
            className="flex flex-col items-center bg-light shadow-md md:hover:shadow-lg p-6 rounded-2xl text-center transition"
          >
            <div className="mb-4">{service.icon}</div>
            <h3 className="mb-2 font-semibold text-dark text-xl">{service.title}</h3>
            <p className="text-secondary text-sm leading-relaxed">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};